import { Component} from '@angular/core';

@Component({
    selector: 'vouchersOrgPaymentPack-main',
    templateUrl: './vouchersOrgPaymentPack-main.tmpl.html'
})

export class VouchersOrgPaymentPackMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  